import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { m as marginPropTypes } from './spacing-7e57ffb0.js';
import { S as SvgIcon } from './SvgIcon-1308e965.js';

function IconCr(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.482 16.737c-2.014 0-3.271-1.685-3.271-3.684 0-2 1.257-3.685 3.271-3.685 1.63 0 2.735 1.137 3.03 2.616H10.87c-.219-.658-.73-1.056-1.386-1.056-1.014 0-1.68.85-1.68 2.123 0 1.273.668 2.122 1.68 2.122.681 0 1.206-.424 1.412-1.123h1.63c-.27 1.523-1.387 2.687-3.044 2.687Zm4.097 0V9.455h1.748v.784c.409-.528 1.05-.87 2.012-.87h.45v1.684h-.465c-.655 0-1.064.142-1.37.414-.349.285-.553.758-.553 1.472v3.798h-1.822Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 3.733a8.268 8.268 0 0 0-8.267 8.268c0 4.566 3.7 8.267 8.265 8.266h8.269V12c0-4.565-3.7-8.268-8.267-8.268ZM2 12.001C2 6.479 6.478 2 12 2c5.524 0 10 4.479 10 10.001V22H11.998C6.476 22.002 2 17.523 2 12.001Z",
    clipRule: "evenodd"
  }));
}
IconCr.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconCr.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconCr as default };
